import type { AlpineComponent } from 'alpinejs'

export default (stateVariable: unknown, indeterminateVariable?: unknown) => {
  if (typeof stateVariable !== 'string') {
    if (DEV_MODE) console.warn('stateVariable is not a string')
    return {}
  }

  if (typeof indeterminateVariable !== 'undefined' && typeof indeterminateVariable !== 'string') {
    if (DEV_MODE) console.warn('indeterminateVariable is not a string')
    return {}
  }

  return {
    init(this: AlpineComponent<any>) {
      this.$el.addEventListener('change', () => {
        if (this.$el.checked) {
          this.$el.dispatchEvent(
            new CustomEvent('switch:on', {
              bubbles: false,
            }),
          )
        } else {
          this.$el.dispatchEvent(
            new CustomEvent('switch:off', {
              bubbles: false,
            }),
          )
        }
      })
      this.$el.addEventListener('click', (event: MouseEvent) => event.stopPropagation())
      this.$el.addEventListener('keyup', (event: KeyboardEvent) => {
        if (event.key === 'Enter') {
          this.$el.click()
          event.preventDefault()
        }
      })
      this.$el.classList.add('cm-toggle-switch')
      this.updateState()
      this.$watch(stateVariable, () => this.updateState())

      if (typeof indeterminateVariable === 'string') {
        this.$watch(indeterminateVariable, () => this.updateState())
      }
    },
    updateState(this: AlpineComponent<any>) {
      let identifiers = stateVariable.split('.')
      let value = null
      if (identifiers.length > 1) {
        value = this[identifiers[0]][identifiers[1]]
      } else {
        value = this[identifiers[0]]
      }

      let isIndeterminate = false
      if (typeof indeterminateVariable !== 'undefined') {
        isIndeterminate = this[indeterminateVariable] === true
      }

      if (value && !isIndeterminate) {
        this.$el.checked = true
      } else {
        this.$el.checked = false
      }

      this.$el.indeterminate = isIndeterminate
    },
  } as AlpineComponent<any>
}
